import React from "react";

import { Spin, Icon, Table, Button, Tooltip, Modal, Row, Col, Input } from "antd";
import { openNotification } from '../../util/notificaciones';

import CentroDriveRequest from '../../services/CentroDrive';
import FormAsignarCentro from './FormAsignarCentro';
import ResponsiveCard from "../Common/ResponsiveCard";
import BaseComponent from "../Common/BaseComponent";

const { confirm } = Modal;

export default class AsignacionCentro extends BaseComponent {
    state = {
        cargando: false,
        disableNuevoCentro: true,
        modalAsignarCentro: false,
        centroAsignadoSelected: null,
        arrCentroDrive: [],
        filtros: {
            filtro: undefined,
            page: undefined
        },
        filterText: "",
        disableApplyFilters: true,
        paginacion: {},
    }

    /**
     * Comportamiento del componente AsignarCentro
     */
    componentDidMount() {
        this.cargarCentroDrive();
    }

    /**
     * Función que se ejecuta para cargar las notificaciónes
     */
    cargarCentroDrive = () => {
        let state = { ...this.state }

        this.setState({ cargando: true }, () => {
            CentroDriveRequest.ListarCentroDrives(state.filtros)
                .then( centroResp => {
                    state.arrCentroDrive = centroResp.data.results;
                    state.paginacion = {
                        current: 1,
                        total: centroResp.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }

                    state.cargando = false;
                    this.setState(state);
                })
                .catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar la configuración del centro suministrador.",
                        "Error al listar las notificaciones",
                        false
                    )
                });
        });
    }

    /**
     * Función para mostar el modal para agregar una nueva asignación del centro suministrador
     * 
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        this.setState({ modalAsignarCentro: true })
    }

    /**
     * Función para esconder modal para agregar un centro suministrador para que le 
     * llegue los pedidos
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state };
        state.modalAsignarCentro = false;
        state.centroAsignadoSelected = null;
        this.setState(state);
        
        if(value) this.cargarCentroDrive()
    }

    /**
     * Función para mostrar la confirmación para eliminar 
     * la notificación.
     * @param: nada.
     * @return: nada.
     */
    showConfirmDelete = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro de eliminar la configuración del centro suministrador?</b> Se borrará la configuración definitivamente.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-eliminar-centro-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-eliminar-centro-form',
            },
            onOk: () => {
                this.setState({ cargando: true });

                CentroDriveRequest.eliminarCentro(this.state.centroAsignadoSelected.id)
                    .then(resp => {
                        this.setState({usrNotificacionSelected: null, cargando:false});
                        openNotification(
                            resp?.data?.cuerpo,
                            resp?.data?.titulo,
                            true
                        );
                        this.cargarCentroDrive();
                    })
                    .catch(err => {
                        this.setState({cargando: false});
                        openNotification(
                            err?.data?.cuerpo,
                            err?.data?.tiulo,
                            false
                        )
                    });
            },
        });
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() === "") {
            state.disableApplyFilters = true
        } else {
            state.disableApplyFilters = false
        }

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.filtro = value.trim() === "" ? undefined : value.trim()

        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     */
    filtrarBack = () => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }
        state.filtros.page = 1;
        state.cargando = true;

        this.setState(state, () => {
            CentroDriveRequest.ListarCentroDrives(state.filtros).then(response => {
                state.arrCentroDrive = response.data.results
                state.cargando = false
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        });
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.filtros.filtro = undefined;
        state.filtros.page = 1;
        state.filterText = "";
        state.arrCentroDrive = [];
        state.paginacion = {};
        state.disableNuevoCentro= true;
        state.centroAsignadoSelected = null;
        this.setState(state, this.filtrarBack);
        openNotification(
            "Los filtros se han limpiado correctamente.", 
            "Filtros limpiados correctamente", 
            true
        );
    }


    render () {
        const columnaAsignacionCentro = [
            {
                title: "Drive",
                dataIndex: "sitio_nombre",
                key: "sitio_nombre"
            },
            {
                title: "Centro Suministrador",
                dataIndex: "centro_nombre",
                key: "centro_nombre"
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Ver detalle del centro suministrador"}>
                                <Button
                                    icon="eye"
                                    id='boton-detalle-centro-modulo'
                                    onClick={() =>{
                                        this.setState({
                                            centroAsignadoSelected: record,
                                            modo: 'ver'
                                        }, this.showModal())
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Editar centro suministrador"}>
                                <Button
                                    icon="edit"
                                    id='boton-detalle-centro-drive'
                                    onClick={() =>{
                                        this.setState({
                                            centroAsignadoSelected: record,
                                            modo: 'editar'
                                        }, this.showModal())
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Eliminar centro suministrador"}>
                                <Button
                                    id='boton-eliminar-centro-drive'
                                    icon="delete"
                                    className="btnEditar"
                                    onClick={() =>{
                                        this.setState({
                                            centroAsignadoSelected: record
                                            }, this.showConfirmDelete)
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                    </div>
                )
            }
        ];

        return (
            <ResponsiveCard
                id="ParentSize"
                title="Módulo asignar drive centro suministrador"
                extra={
                    <div>
                        <Button
                            className="btnVerCrearGuardar"
                            type="primary"
                            id="boton-nueva-asignacion"
                            onClick={() => {
                                this.setState({ modo: 'nuevo', tipo_modal: 'editar' }, () => {
                                    this.showModal();
                                })

                            }}
                        >
                            Nueva asignación
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row>
                            <Col span={12}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Drive">
                                    <Input
                                        autoFocus={true}
                                        maxLength={50}
                                        id="input-buscar-categoria-modulo"
                                        placeholder="Buscar por Drive / Centro suministrador"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <div className="center-down">
                                    <Tooltip placement="top" title="Borrar filtros">
                                        <Button 
                                            id="boton-borrar-filtros-articulos" 
                                            type="default" 
                                            icon="delete" 
                                            className={this.state.disableApplyFilters ? 'disableBtn' : ''} 
                                            style={{ width: '100%', marginBottom: "30px", marginTop: '1.3em' }} 
                                            onClick={this.cleanFilters}
                                        >
                                        </Button>
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                    >
                        <Table
                            size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            columns={columnaAsignacionCentro}
                            rowKey={usuarios => usuarios.id}
                            dataSource={this.state.arrCentroDrive}
                            pagination={this.state.paginacion}
                        />
                    </Spin>
                </div>
                <FormAsignarCentro
                    esconderModal={this.esconderModal}
                    modo={this.state.modo}
                    visible={this.state.modalAsignarCentro}
                    centroAsignado_selected={this.state.centroAsignadoSelected}
                >
                </FormAsignarCentro>
            </ResponsiveCard>
        );
    }
}